import React, { useState, useEffect, useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSearch, faUser, faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { SidebarContext } from '../context/SidebarContext';

const Header = () => {
    const { toggleSidebar } = useContext(SidebarContext)
    const [search, setSearch] = useState('');
    const [tablatures, setTablatures] = useState([]);
    const [isDarkMode, setIsDarkMode] = useState(false);
    const navigate = useNavigate();

    const handleUserIconClick = () => {
        navigate("/connexion");
    };

    const handleSearchInputChange = (e) => {
        setSearch(e.target.value);
    };

    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API}/tabs`)
            .then((response) => {
                setTablatures(response.data);
            })
            .catch((error) => {
                console.log('Erreur lors de la récupération des tablatures:', error);
            });
    }, []);

    useEffect(() => {
        if (isDarkMode) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }, [isDarkMode]);

    return (
        <header className="header">
            <nav className="flex">
                <NavLink to="/" className="logo">
                    Ukulearn.
                </NavLink>
                <form onSubmit={(e) => e.preventDefault()} className="search-form">
                    <input
                        type="text"
                        id="search_box"
                        name="search_box"
                        required
                        placeholder="Entrez votre recherche..."
                        maxLength="100"
                        value={search}
                        onChange={handleSearchInputChange}
                    />
                    <button type="submit">
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </form>

                <ul className="icons">
                    <li id="menu-btn" className="icon hide-on-desktop" onClick={toggleSidebar}>
                        <FontAwesomeIcon icon={faBars} />
                    </li>


                    <li id="user-btn" className="icon" onClick={handleUserIconClick}>
                        <FontAwesomeIcon icon={faUser} />
                    </li>

                    <li id="toggle-btn" className="icon" onClick={toggleDarkMode}>
                        <FontAwesomeIcon icon={isDarkMode ? faMoon : faSun} />
                    </li>
                </ul>
            </nav>

            {search && (
                <article className="search-results">
                    <h3 className="result">Résultats de recherche :</h3>
                    {tablatures
                        .filter((tablature) =>
                            tablature.artist.toLowerCase().includes(search.toLowerCase()) ||
                            tablature.title.toLowerCase().includes(search.toLowerCase())
                        )
                        .map((tablature) => (
                            <p key={tablature._id}>
                                {tablature.artist} - {tablature.title}
                            </p>
                        ))}
                </article>
            )}
        </header>
        
    );
};

export default Header;
